module.exports = __webpack_public_path__ + "img/ShouanPan.f438af0c.jpg";